
import { defineComponent } from 'vue';
import deviceDetail from '@/components/view/common/device-info/index.vue';

export default defineComponent({
    components: {
        deviceDetail
    }
});
